import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import GameArtifact from './game-artifact-model'
import {
  CreateGameArtifactAsync,
  DeleteGameArtifactAsync,
  LoadGameArtifactsAsync,
} from './gameArtifact-thunk'
const initialState: gameArtifactSliceState = {
  gameArtifact: [],
  selected_gameArtifact: '',
  is_loading_gameArtifact: false,
  is_creating_gameArtifact: false,
  is_deleting_gameArtifact: false,
}
export interface gameArtifactSliceState {
  gameArtifact: GameArtifact[]
  selected_gameArtifact?: string
  is_loading_gameArtifact: boolean
  is_creating_gameArtifact: boolean
  is_deleting_gameArtifact: boolean
}
export const gameArtifactSlice = createSlice({
  name: 'gameArtifact',
  initialState,
  reducers: {
    setSelectedgameArtifact: (state, action) => {
      state.selected_gameArtifact = action.payload
    },
    clearStategameArtifact: (state) => {
      state.gameArtifact = []
      state.is_loading_gameArtifact = false
      state.is_creating_gameArtifact = false
      state.is_deleting_gameArtifact = false
    },
    mergegameArtifact: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_gameArtifact = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.gameArtifact = merge(state.gameArtifact, payload) as any
        }
      }
    },

    add_gameArtifact: (state, action) => {
      if (action.payload) {
        state.gameArtifact = [...state.gameArtifact, action.payload]
      }
    },
    set_gameArtifact: (state, action) => {
      let { key, value, id } = action.payload
      state.gameArtifact = state.gameArtifact.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadGameArtifactsAsync.pending, (state) => {
      state.is_loading_gameArtifact = true
    })
    builder.addCase(LoadGameArtifactsAsync.fulfilled, (state, action) => {
      state.is_loading_gameArtifact = false
      if (action.payload) {
        state.gameArtifact = action.payload
      }
    })
    builder.addCase(LoadGameArtifactsAsync.rejected, (state) => {
      state.is_loading_gameArtifact = false
    })
    builder.addCase(CreateGameArtifactAsync.pending, (state) => {
      state.is_creating_gameArtifact = true
    })
    builder.addCase(CreateGameArtifactAsync.fulfilled, (state) => {
      state.is_creating_gameArtifact = false
    })
    builder.addCase(CreateGameArtifactAsync.rejected, (state) => {
      state.is_creating_gameArtifact = false
    })
    builder.addCase(DeleteGameArtifactAsync.pending, (state) => {
      state.is_deleting_gameArtifact = true
    })
    builder.addCase(DeleteGameArtifactAsync.fulfilled, (state, action) => {
      state.is_deleting_gameArtifact = false
      if (state.gameArtifact) {
        state.gameArtifact = state.gameArtifact.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteGameArtifactAsync.rejected, (state) => {
      state.is_deleting_gameArtifact = false
    })
  },
})

export const {
  clearStategameArtifact,
  setSelectedgameArtifact,
  set_gameArtifact,
  mergegameArtifact,
  add_gameArtifact,
} = gameArtifactSlice.actions

export const get_gameArtifact =
  (id?: string) =>
  (state: {
    gameArtifact: {
      gameArtifact: GameArtifact[]
    }
  }): GameArtifact | null => {
    let temp = state?.gameArtifact?.gameArtifact?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.gameArtifact?.gameArtifact[0] || null
  }
export const get_selected_gameArtifact = (state: {
  gameArtifact: gameArtifactSliceState
}): GameArtifact | null => {
  let id = state?.gameArtifact?.selected_gameArtifact
  let temp = state?.gameArtifact?.gameArtifact?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_gameArtifact = (state: {
  gameArtifact: {
    gameArtifact: GameArtifact[]
  }
}): GameArtifact[] => {
  let temp = state?.gameArtifact?.gameArtifact
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_gameArtifact_busy = (state: {
  gameArtifact: gameArtifactSliceState
}) => {
  return (
    state?.gameArtifact.is_deleting_gameArtifact ||
    state?.gameArtifact.is_loading_gameArtifact ||
    state?.gameArtifact.is_creating_gameArtifact
  )
}
export const is_deleting_gameArtifact_busy = (state: {
  gameArtifact: gameArtifactSliceState
}) => {
  return state?.gameArtifact.is_deleting_gameArtifact
}
export const is_loading_gameArtifact_busy = (state: {
  gameArtifact: gameArtifactSliceState
}) => {
  return state?.gameArtifact.is_loading_gameArtifact
}
export const is_creating_gameArtifact_busy = (state: {
  gameArtifact: gameArtifactSliceState
}) => {
  return state?.gameArtifact.is_creating_gameArtifact
}

export default gameArtifactSlice.reducer
